export default "__VITE_ASSET__8ipOu1JM__ 800w";